import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { types } from 'src/common/utils/guideItemTypes';
import ShareDialog from '../shared/dialog/ShareDialog';
import canEmbed from '../../utils/guideItem/canEmbed';
import FavoriteButton from './FavoriteButton';
import ShareButton from './ShareButton';
import DonateButton from './DonateButton';
import css from './social-controls.module.scss';

export default class SocialControls extends Component {
  static propTypes = {
    canFollow: PropTypes.bool.isRequired,
    isFollowing: PropTypes.bool.isRequired,
    guideItem: PropTypes.object.isRequired,
    handleFavoriteToggle: PropTypes.func.isRequired,
    handleSharing: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isShowingShareDialog: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.guideItem.guideId !== this.props.guideItem.guideId) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isShowingShareDialog: false,
      });
    }
  }

  toggleShareDialog = () => {
    if (!this.state.isShowingShareDialog) {
      this.props.handleSharing();
    }

    this.setState({
      isShowingShareDialog: !this.state.isShowingShareDialog,
    });
  };

  generateFavoriteBtnClassName = (showShareBtn, showDonateBtn) => {
    if (showShareBtn || showDonateBtn) {
      return css.buttonListItem;
    }

    return css.button;
  };

  render() {
    const { guideItem, canFollow, isFollowing, handleFavoriteToggle } =
      this.props;
    const shouldShowShareButton = get(guideItem, 'actions.share.canShare');
    const shareMeta = {
      guideId: guideItem.guideId,
      image: guideItem.image,
      title: guideItem.title,
      subtitle: guideItem.subtitle,
      shareUrl: get(guideItem, 'actions.share.shareUrl'),
      shareText: get(guideItem, 'actions.share.shareText'),
      slogan: get(guideItem, 'metadata.properties.station.slogan'),
    };

    let donateAction = get(guideItem, 'actions.donate');

    // find donate action in donatePrompt
    if (!donateAction && guideItem.containerItems) {
      guideItem.containerItems.some(({ children = [] }) => {
        const promptItem = children.find(({ type }) => type === types.prompt);
        const action = get(promptItem, 'actions.donate');
        if (action) donateAction = action;
        return !!action;
      });
    }

    const canDonate = get(donateAction, 'canDonate');
    const donateButtonText = get(donateAction, 'text');
    const donateButtonUrl = get(donateAction, 'url');
    const shouldShowDonateButton = !!canDonate && !!donateButtonUrl;
    const favoriteBtnClassName = this.generateFavoriteBtnClassName(
      shouldShowShareButton,
      shouldShowDonateButton,
    );

    return (
      <Fragment>
        <div className={css.wrapper}>
          {canFollow && (
            <FavoriteButton
              key="Favorite"
              className={favoriteBtnClassName}
              isFollowing={isFollowing}
              handleFavoriteToggle={handleFavoriteToggle}
            />
          )}
          {shouldShowShareButton && (
            <ShareButton
              key={`profileShareButton-${guideItem.guideId}`}
              className={
                shouldShowDonateButton ? css.buttonListItem : css.button
              }
              toggleShareDialog={this.toggleShareDialog}
            />
          )}
          {shouldShowDonateButton && (
            <DonateButton
              key="donate"
              className={css.button}
              text={donateButtonText}
              url={donateButtonUrl}
            />
          )}
        </div>
        {shouldShowShareButton && (
          <ShareDialog
            key="profileShareDialog"
            shareMeta={shareMeta}
            showEmbed={canEmbed(guideItem)}
            isActive={this.state.isShowingShareDialog}
            toggleShareDialog={this.toggleShareDialog}
          />
        )}
      </Fragment>
    );
  }
}
